import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_templatesplugin2861d90d_1da265c6 from 'nuxt_plugin_templatesplugin2861d90d_1da265c6' // Source: ./templates.plugin.2861d90d.js (mode: 'all')
import nuxt_plugin_axios_73956c52 from 'nuxt_plugin_axios_73956c52' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginclient_074e02a4 from 'nuxt_plugin_pluginclient_074e02a4' // Source: ../plugins/devtools/plugin.client.js (mode: 'client')
import nuxt_plugin_integrations_89e440d6 from 'nuxt_plugin_integrations_89e440d6' // Source: ../plugins/integrations (mode: 'all')
import nuxt_plugin_getImageUrl_568f69ba from 'nuxt_plugin_getImageUrl_568f69ba' // Source: ../plugins/getImageUrl.js (mode: 'all')
import nuxt_plugin_timing_79a0d6b7 from 'nuxt_plugin_timing_79a0d6b7' // Source: ../plugins/timing.js (mode: 'all')
import nuxt_plugin_clientIpserver_479155a4 from 'nuxt_plugin_clientIpserver_479155a4' // Source: ../plugins/clientIp.server.js (mode: 'server')
import nuxt_plugin_pluginserver_6ebdf93c from 'nuxt_plugin_pluginserver_6ebdf93c' // Source: ../plugins/device/plugin.server.js (mode: 'server')
import nuxt_plugin_handleCookiesserver_1accd5b7 from 'nuxt_plugin_handleCookiesserver_1accd5b7' // Source: ../plugins/handleCookies.server.js (mode: 'server')
import nuxt_plugin_handleCookiesclient_95d937a2 from 'nuxt_plugin_handleCookiesclient_95d937a2' // Source: ../plugins/handleCookies.client.js (mode: 'client')
import nuxt_plugin_initserver_0f1e196c from 'nuxt_plugin_initserver_0f1e196c' // Source: ../plugins/init.server.js (mode: 'server')
import nuxt_plugin_fitmentserver_409284df from 'nuxt_plugin_fitmentserver_409284df' // Source: ../plugins/fitment.server.js (mode: 'server')
import nuxt_plugin_globalAxios_4d4dbb7a from 'nuxt_plugin_globalAxios_4d4dbb7a' // Source: ../plugins/globalAxios.js (mode: 'all')
import nuxt_plugin_pluginserver_6f584af8 from 'nuxt_plugin_pluginserver_6f584af8' // Source: ../plugins/sitewide/plugin.server.js (mode: 'server')
import nuxt_plugin_proxy_3bae095b from 'nuxt_plugin_proxy_3bae095b' // Source: ../integrations/bugsnag/proxy.js (mode: 'all')
import nuxt_plugin_pluginclient_099ed970 from 'nuxt_plugin_pluginclient_099ed970' // Source: ../plugins/sitewide/plugin.client.js (mode: 'client')
import nuxt_plugin_meta_6a83867b from 'nuxt_plugin_meta_6a83867b' // Source: ../plugins/meta (mode: 'all')
import nuxt_plugin_pluginserver_22f44026 from 'nuxt_plugin_pluginserver_22f44026' // Source: ../plugins/meta/plugin.server.js (mode: 'server')
import nuxt_plugin_uiBusclient_55931bf4 from 'nuxt_plugin_uiBusclient_55931bf4' // Source: ../plugins/uiBus.client.js (mode: 'client')
import nuxt_plugin_pluginclient_090487b4 from 'nuxt_plugin_pluginclient_090487b4' // Source: ../plugins/device/plugin.client.js (mode: 'client')
import nuxt_plugin_recommendationsclient_106772fc from 'nuxt_plugin_recommendationsclient_106772fc' // Source: ../plugins/recommendations.client.js (mode: 'client')
import nuxt_plugin_promoCodesclient_d2eca42a from 'nuxt_plugin_promoCodesclient_d2eca42a' // Source: ../plugins/promoCodes.client.js (mode: 'client')
import nuxt_plugin_emailTrackerclient_153f51d0 from 'nuxt_plugin_emailTrackerclient_153f51d0' // Source: ../plugins/emailTracker.client.js (mode: 'client')
import nuxt_plugin_vueScrollToclient_f4bec714 from 'nuxt_plugin_vueScrollToclient_f4bec714' // Source: ../plugins/vueScrollTo.client.js (mode: 'client')
import nuxt_plugin_pushclient_a37b2524 from 'nuxt_plugin_pushclient_a37b2524' // Source: ../plugins/push.client.js (mode: 'client')
import nuxt_plugin_overlay_15f6139d from 'nuxt_plugin_overlay_15f6139d' // Source: ../plugins/overlay.js (mode: 'all')
import nuxt_plugin_notifications_15a88b85 from 'nuxt_plugin_notifications_15a88b85' // Source: ../plugins/notifications.js (mode: 'all')
import nuxt_plugin_nuxtReadyclient_699129f0 from 'nuxt_plugin_nuxtReadyclient_699129f0' // Source: ../plugins/nuxtReady.client.js (mode: 'client')
import nuxt_plugin_lazyloadclient_39cac1ae from 'nuxt_plugin_lazyloadclient_39cac1ae' // Source: ../plugins/lazyload.client.js (mode: 'client')
import nuxt_plugin_proxy_41109330 from 'nuxt_plugin_proxy_41109330' // Source: ../integrations/accessibe/proxy.js (mode: 'all')
import nuxt_plugin_proxy_7f8fda7d from 'nuxt_plugin_proxy_7f8fda7d' // Source: ../integrations/affirm/proxy.js (mode: 'all')
import nuxt_plugin_proxy_5562f9bf from 'nuxt_plugin_proxy_5562f9bf' // Source: ../integrations/algolia/proxy.js (mode: 'all')
import nuxt_plugin_proxy_86a2dbea from 'nuxt_plugin_proxy_86a2dbea' // Source: ../integrations/bolt/proxy.js (mode: 'all')
import nuxt_plugin_proxy_2f2afd29 from 'nuxt_plugin_proxy_2f2afd29' // Source: ../integrations/brightedge/proxy.js (mode: 'all')
import nuxt_plugin_proxy_3b4e48c2 from 'nuxt_plugin_proxy_3b4e48c2' // Source: ../integrations/cognito/proxy.js (mode: 'all')
import nuxt_plugin_proxy_4faf5024 from 'nuxt_plugin_proxy_4faf5024' // Source: ../integrations/ella/proxy.js (mode: 'all')
import nuxt_plugin_proxy_2b84e170 from 'nuxt_plugin_proxy_2b84e170' // Source: ../integrations/forter/proxy.js (mode: 'all')
import nuxt_plugin_proxy_b376e2ac from 'nuxt_plugin_proxy_b376e2ac' // Source: ../integrations/geolocation/proxy.js (mode: 'all')
import nuxt_plugin_proxy_13bf7abb from 'nuxt_plugin_proxy_13bf7abb' // Source: ../integrations/googlePlaces/proxy.js (mode: 'all')
import nuxt_plugin_proxy_1829a0b4 from 'nuxt_plugin_proxy_1829a0b4' // Source: ../integrations/googleTagManager/proxy.js (mode: 'all')
import nuxt_plugin_proxy_1cbfa0ea from 'nuxt_plugin_proxy_1cbfa0ea' // Source: ../integrations/installernet/proxy.js (mode: 'all')
import nuxt_plugin_proxy_46dbfb04 from 'nuxt_plugin_proxy_46dbfb04' // Source: ../integrations/invoca/proxy.js (mode: 'all')
import nuxt_plugin_proxy_04d57cdf from 'nuxt_plugin_proxy_04d57cdf' // Source: ../integrations/liveperson/proxy.js (mode: 'all')
import nuxt_plugin_proxy_6c31d56d from 'nuxt_plugin_proxy_6c31d56d' // Source: ../integrations/paypal/proxy.js (mode: 'all')
import nuxt_plugin_proxy_98a407c6 from 'nuxt_plugin_proxy_98a407c6' // Source: ../integrations/segment/proxy.js (mode: 'all')
import nuxt_plugin_proxy_04e61c35 from 'nuxt_plugin_proxy_04e61c35' // Source: ../integrations/storyblok/proxy.js (mode: 'all')
import nuxt_plugin_proxy_e5a48d5a from 'nuxt_plugin_proxy_e5a48d5a' // Source: ../integrations/stripe/proxy.js (mode: 'all')
import nuxt_plugin_proxy_b836064c from 'nuxt_plugin_proxy_b836064c' // Source: ../integrations/wisepops/proxy.js (mode: 'all')
import nuxt_plugin_proxy_3aaf1df3 from 'nuxt_plugin_proxy_3aaf1df3' // Source: ../integrations/yotpo/proxy.js (mode: 'all')
import nuxt_plugin_providerCheck_60bdb076 from 'nuxt_plugin_providerCheck_60bdb076' // Source: ../plugins/providerCheck.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"en"},"title":"","meta":[{"charset":"utf-8","once":true},{"name":"viewport","content":"width=device-width,initial-scale=1.0,maximum-scale=5,user-scalable=0","once":true},{"name":"format-detection","content":"telephone=no","once":true}],"link":[{"rel":"preconnect","href":"https:\u002F\u002Fuwp.thiecommerce.com","crossorigin":true,"once":true}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_templatesplugin2861d90d_1da265c6 === 'function') {
    await nuxt_plugin_templatesplugin2861d90d_1da265c6(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_73956c52 === 'function') {
    await nuxt_plugin_axios_73956c52(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_074e02a4 === 'function') {
    await nuxt_plugin_pluginclient_074e02a4(app.context, inject)
  }

  if (typeof nuxt_plugin_integrations_89e440d6 === 'function') {
    await nuxt_plugin_integrations_89e440d6(app.context, inject)
  }

  if (typeof nuxt_plugin_getImageUrl_568f69ba === 'function') {
    await nuxt_plugin_getImageUrl_568f69ba(app.context, inject)
  }

  if (typeof nuxt_plugin_timing_79a0d6b7 === 'function') {
    await nuxt_plugin_timing_79a0d6b7(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_clientIpserver_479155a4 === 'function') {
    await nuxt_plugin_clientIpserver_479155a4(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_6ebdf93c === 'function') {
    await nuxt_plugin_pluginserver_6ebdf93c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_handleCookiesserver_1accd5b7 === 'function') {
    await nuxt_plugin_handleCookiesserver_1accd5b7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_handleCookiesclient_95d937a2 === 'function') {
    await nuxt_plugin_handleCookiesclient_95d937a2(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_initserver_0f1e196c === 'function') {
    await nuxt_plugin_initserver_0f1e196c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_fitmentserver_409284df === 'function') {
    await nuxt_plugin_fitmentserver_409284df(app.context, inject)
  }

  if (typeof nuxt_plugin_globalAxios_4d4dbb7a === 'function') {
    await nuxt_plugin_globalAxios_4d4dbb7a(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_6f584af8 === 'function') {
    await nuxt_plugin_pluginserver_6f584af8(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_3bae095b === 'function') {
    await nuxt_plugin_proxy_3bae095b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_099ed970 === 'function') {
    await nuxt_plugin_pluginclient_099ed970(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_6a83867b === 'function') {
    await nuxt_plugin_meta_6a83867b(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_22f44026 === 'function') {
    await nuxt_plugin_pluginserver_22f44026(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_uiBusclient_55931bf4 === 'function') {
    await nuxt_plugin_uiBusclient_55931bf4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_090487b4 === 'function') {
    await nuxt_plugin_pluginclient_090487b4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_recommendationsclient_106772fc === 'function') {
    await nuxt_plugin_recommendationsclient_106772fc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_promoCodesclient_d2eca42a === 'function') {
    await nuxt_plugin_promoCodesclient_d2eca42a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_emailTrackerclient_153f51d0 === 'function') {
    await nuxt_plugin_emailTrackerclient_153f51d0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueScrollToclient_f4bec714 === 'function') {
    await nuxt_plugin_vueScrollToclient_f4bec714(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pushclient_a37b2524 === 'function') {
    await nuxt_plugin_pushclient_a37b2524(app.context, inject)
  }

  if (typeof nuxt_plugin_overlay_15f6139d === 'function') {
    await nuxt_plugin_overlay_15f6139d(app.context, inject)
  }

  if (typeof nuxt_plugin_notifications_15a88b85 === 'function') {
    await nuxt_plugin_notifications_15a88b85(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtReadyclient_699129f0 === 'function') {
    await nuxt_plugin_nuxtReadyclient_699129f0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazyloadclient_39cac1ae === 'function') {
    await nuxt_plugin_lazyloadclient_39cac1ae(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_41109330 === 'function') {
    await nuxt_plugin_proxy_41109330(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_7f8fda7d === 'function') {
    await nuxt_plugin_proxy_7f8fda7d(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_5562f9bf === 'function') {
    await nuxt_plugin_proxy_5562f9bf(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_86a2dbea === 'function') {
    await nuxt_plugin_proxy_86a2dbea(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_2f2afd29 === 'function') {
    await nuxt_plugin_proxy_2f2afd29(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_3b4e48c2 === 'function') {
    await nuxt_plugin_proxy_3b4e48c2(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_4faf5024 === 'function') {
    await nuxt_plugin_proxy_4faf5024(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_2b84e170 === 'function') {
    await nuxt_plugin_proxy_2b84e170(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_b376e2ac === 'function') {
    await nuxt_plugin_proxy_b376e2ac(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_13bf7abb === 'function') {
    await nuxt_plugin_proxy_13bf7abb(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_1829a0b4 === 'function') {
    await nuxt_plugin_proxy_1829a0b4(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_1cbfa0ea === 'function') {
    await nuxt_plugin_proxy_1cbfa0ea(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_46dbfb04 === 'function') {
    await nuxt_plugin_proxy_46dbfb04(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_04d57cdf === 'function') {
    await nuxt_plugin_proxy_04d57cdf(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_6c31d56d === 'function') {
    await nuxt_plugin_proxy_6c31d56d(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_98a407c6 === 'function') {
    await nuxt_plugin_proxy_98a407c6(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_04e61c35 === 'function') {
    await nuxt_plugin_proxy_04e61c35(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_e5a48d5a === 'function') {
    await nuxt_plugin_proxy_e5a48d5a(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_b836064c === 'function') {
    await nuxt_plugin_proxy_b836064c(app.context, inject)
  }

  if (typeof nuxt_plugin_proxy_3aaf1df3 === 'function') {
    await nuxt_plugin_proxy_3aaf1df3(app.context, inject)
  }

  if (typeof nuxt_plugin_providerCheck_60bdb076 === 'function') {
    await nuxt_plugin_providerCheck_60bdb076(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    const { route } = router.resolve(app.context.route.fullPath)
    // Ignore 404s rather than blindly replacing URL
    if (!route.matched.length && process.client) {
      return resolve()
    }
    router.replace(route, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
